<template>
  <div class="Footbar">
      <slot />
      <div class="footbar">
        <slot name="footbar" />
        </div>
  </div>
</template>

<script>
export default {
  name: 'Footbar'
}
</script>

<style lang="less">
.Footbar {
  .footbar {
    position: fixed;
    bottom: 0;
    left: 50%;
    z-index: 1000;
    width: 100%;
    transform: translateX(-50%);
    box-shadow: 0 -2px 3px #F4F4F4;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: #FFFFFF;
  }
}
</style>
